export default __webpack_public_path__ + "static/pair-icon-light-452170a14a4ba0519cf5ef695756ef07.png";